import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import FilmIntro from "@/pages/home/components/FilmIntro";
import SectionHeading from "@/components/base/SectionHeading";
import ReviewCard from "@/components/feature/ReviewCard";
import NewsCard from "@/components/feature/NewsCard";
import useSeo from "@/hooks/useSeo";
import { reviews } from "@/mocks/reviews";
import { news } from "@/mocks/news";

export default function Home() {
  useSeo({
    title: "激情丛林电影 - 最新剧情介绍与影评",
    description:
      "激情丛林电影官网，提供电影《激情丛林》的最新剧情介绍、影评和相关资讯，助您深入了解影片内容和背景。这里汇聚丰富电影资源，方便影迷查阅。",
    keywords: "激情丛林电影,激情丛林,电影剧情,电影影评,电影资讯,影片介绍,影视内容",
  });

  const latestReviews = [...reviews].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 5);
  const latestNews = [...news].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 3);

  return (
    <div className="w-full">
      <h1 className="sr-only">激情丛林电影 - 最新剧情介绍与影评</h1>

      <HeroCarousel />
      <CategoryEntries />
      <FilmIntro />

      <section className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Latest Reviews"
          title="最新影评"
          desc="来自专业影评人与观众的声音，记录关于这部影片的每一次讨论。"
          action={
            <Link
              to="/reviews"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-600 px-4 py-2.5 font-label text-sm text-foreground-200 transition-colors hover:border-primary-500 hover:text-accent-400"
            >
              查看全部影评
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <div className="flex flex-col gap-4">
          {latestReviews.map((review) => (
            <ReviewCard key={review.id} review={review} />
          ))}
        </div>
      </section>

      <section className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="News & Updates"
          title="最新资讯简报"
          desc="幕后花絮、活动报道与官方公告，关于《激情丛林》的一切进展。"
          action={
            <Link
              to="/news"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-600 px-4 py-2.5 font-label text-sm text-foreground-200 transition-colors hover:border-primary-500 hover:text-accent-400"
            >
              查看全部资讯
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {latestNews.map((item) => (
            <NewsCard key={item.id} item={item} />
          ))}
        </div>
      </section>
    </div>
  );
}